module.exports = __webpack_public_path__ + "static/image-04-a@2x-fefbab30c118cb201ac3b3d81090cf07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cookpad/image-04-a@2x.jpg
// module id = 349
// module chunks = 3627797113349 20562973939449 33019919093843